export default __webpack_public_path__ + "static/media/Log.cf77dcc0.svg";